import EditPatientDrawer from './EditPatientDrawer';

export default EditPatientDrawer;
